import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { DeviceData } from "../../Models/Device";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";

export class DevicesVM extends InterActive{
    private list:DeviceData[] = []
    private name:string  = ''

    public get List():DeviceData[] { return this.list}
    public get Name():string { return this.name }

    public set Name(value:string ){ this.name= value; this.update() }

    public getList(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getAllDevices()
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.list = response.data.data
                                this.update()
                            }else Notify({type:'danger' , title:'فشل العميلة' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل العميلة' , body:'فشل عملية تعديل الصلاحيات ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                    Notify({type:'danger' , title:'فشل العميلة' , body:'فشل عملية تعديل الصلاحيات ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
        )
    }

    public async addDevice(){
        if(this.name == ''){
            Notify({type:'danger' , title:'بيانات غير صالحة' , body:'برجاء ادخال اسم الجهاز'})
            return;
        }
        try{
            const response = await ApiRequest.createDevice(this.name)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        this.name = ''
                        this.getList()
                    }else {
                        Notify({type:'danger' , title:'فشل العميلة' , body:response.data.messege})
                    }
                }else Notify({type:'danger' , title:'فشل العميلة' , body:'فشل عملية تعديل الصلاحيات ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{ Notify({type:'danger' , title:'فشل العميلة' , body:'فشل عملية تعديل الصلاحيات ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
    }

    public async removeDevice(id:string){
        try{
            const response = await ApiRequest.removeDevice(id)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        this.getList()
                    }else {
                        Notify({type:'danger' , title:'فشل العميلة' , body:response.data.messege})
                    }
                }else Notify({type:'danger' , title:'فشل العميلة' , body:'فشل عملية تعديل الصلاحيات ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{ Notify({type:'danger' , title:'فشل العميلة' , body:'فشل عملية تعديل الصلاحيات ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }

    }

    public async deactivateDevice(id:string){
        try{
            const response = await ApiRequest.deactivateDevice(id)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        this.getList()
                    }else {
                        Notify({type:'danger' , title:'فشل العميلة' , body:response.data.messege})
                    }
                }else Notify({type:'danger' , title:'فشل العميلة' , body:'فشل عملية تعديل الصلاحيات ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{ Notify({type:'danger' , title:'فشل العميلة' , body:'فشل عملية تعديل الصلاحيات ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }

    }

}